export const UM_CONTEXT_KEYS = {
  all: ['userManagement', 'umContext'] as const,
  notifications: () => [...UM_CONTEXT_KEYS.all, 'notifications'] as const
};
